import { sections } from "./sections.js";

/*
 * The tutorial flattened into searchable entries, one per step plus one per
 * section's tips. Used twice:
 *
 *  - in the browser, by search.js, to jump to the right screenshot the moment
 *    a question is asked;
 *  - on the server, as the only knowledge the "Ask" assistant has. That copy is
 *    backend-nextja/src/lib/tutorialCorpus.generated.json, written by
 *    `node scripts/sync-tutorial-corpus.mjs` — re-run it after editing
 *    sections.js, or the assistant answers from the old text.
 *
 * `id` is the step's anchor on the page (`order-2`), which is how the
 * assistant's sources link back to a screenshot.
 */
export const plain = (html) =>
  html
    .replace(/\[(\d+)\]/g, "(marker $1)")
    .replace(/<[^>]+>/g, "")
    .replace(/&amp;/g, "&")
    .replace(/\s+/g, " ")
    .trim();

export function buildCorpus() {
  const entries = [];
  for (const section of sections) {
    section.steps.forEach((step, index) => {
      entries.push({
        id: `${section.id}-${index + 1}`,
        section: section.id,
        sectionTitle: section.title,
        title: step.title,
        image: step.image || null,
        // A `<image>-m.webp` phone screenshot exists (rendered below 640px).
        mobile: !!step.mobile,
        page: step.link?.to || null,
        text: [index === 0 && section.intro ? plain(section.intro) : null, ...step.body.map(plain)]
          .filter(Boolean)
          .join("\n"),
      });
    });
    if (section.tips?.length) {
      entries.push({
        id: `${section.id}-tips`,
        section: section.id,
        sectionTitle: section.title,
        title: "Tips",
        image: null,
        mobile: false,
        page: null,
        text: section.tips.map(plain).join("\n"),
      });
    }
  }
  return entries;
}
